import React, { createContext, useContext, useState } from "react";
import { AdminLogRepository } from "../../repository/AdminDashboard/Admin-Repository";

const StateContext = createContext();

// Define initial state for admin log
const initialState = {
  AdminLog: [],
  req: {
    id: "",
    text: "",
    pagenumber: "",
  },
};

// AdminLogContext component to manage admin log state
const AdminLogContext = ({ children }) => {
  const [AdminLog, setAdminLog] = useState(initialState.AdminLog);
  const [adminName, setadminName] = useState("");
  const [text, settext] = useState("");
  const [loaded, setloaded] = useState(false);
  const [id, setid] = useState("");
  const [pagenumber, setpagenumber] = useState(1);
  const [countallPge, setcountallPge] = useState(10);

  // Function to fetch admin log data
  const getLog = async (id, text, pageNumber) => {
    const data = {
      id: id,
      text: text,
      pagenumber: pageNumber,
    };

    const adminLog_data = await AdminLogRepository.getLogAdmin(data);
    setAdminLog(adminLog_data.adminLogList);
    setcountallPge(adminLog_data.countAllPages);
    setadminName(adminLog_data.name);
  };

  // Function to fetch admin log on component mount
  const onLog = async (id_data) => {
    setid(id_data);
    await getLog(id_data, text, pagenumber);
    setloaded(true);
  };

  // Function to handle log search
  const BtnlogSearch = async (e) => {
    setloaded(false);
    e.preventDefault();
    await getLog(id, text, pagenumber);
    setloaded(true);
  };

  // Function to handle text input change
  const logtext = (e) => {
    const tex = e.target.value;
    settext(tex);
  };

  // Function to handle pagination change
  const changePage = async ({ selected }) => {
    setloaded(false);
    setpagenumber(selected + 1);
    await getLog(id, text, selected + 1);
    setloaded(true);
  };

  // Update request data in initial state
  initialState.req.id = id;
  initialState.req.text = text;
  initialState.req.pagenumber = pagenumber;
  
  return (
    <StateContext.Provider
      value={{
        AdminLog,
        onLog,
        BtnlogSearch,
        logtext,
        loaded,
        countallPge,
        pagenumber,
        changePage,
        adminName,
      }}>
      {children}
    </StateContext.Provider>
  );
};

// Custom hook to consume admin log context
function AdminLogStateContext() {
  return React.useContext(StateContext);
}

export { AdminLogStateContext };
export default AdminLogContext;
